<template>
  <el-dialog
    :title="type===1?'分配班组':type===2?`分配${value.personType==='WORKER'?'工种':'岗位'}`:''"
    width="500px"
    :visible.sync="dialogVisible"
    :before-close="close"
    :close-on-click-modal="false"
    append-to-body
    class="AllotDialog"
  >
    <el-form
      ref="form"
      :model="value"
      :rules="rules"
      label-width="100px"
    >
      <el-form-item
        v-if="type===1"
        label="所属企业"
        prop="companyId"
      >
        <CommonSelect
          v-model="value.companyId"
          :request="siteProjectCompanyList"
          :props="{label:'companyName',value:'companyId'}"
          :params="companyParams"
          placeholder="请选择企业"
          @change="companyChange"
        />
      </el-form-item>
      <el-form-item
        v-if="type===1"
        label="班组"
        prop="teamId"
      >
        <CommonSelect
          ref="CommonSelect"
          v-model="value.teamId"
          :request="siteTeamTree"
          :props="{label:'teamName',value:'teamId'}"
          :params="teamParams"
          placeholder="请选择班组"
        />
      </el-form-item>
      <el-form-item
        v-if="type===2&&value.personType==='WORKER'"
        label="工种"
        prop="workerTypeId"
      >
        <DictionarySelect
          v-model="value.workerTypeId"
          placeholder="请选择工种"
          dictionary-type-code="workerType"
        />
      </el-form-item>
      <el-form-item
        v-if="type===2&&value.personType==='MANAGER'"
        label="岗位"
        prop="workerTypeId"
      >
        <DictionarySelect
          v-model="value.workerTypeId"
          placeholder="请选择岗位"
          dictionary-type-code="managerType"
        />
      </el-form-item>
      <el-form-item
        v-if="type===2&&value.personType==='OTHER'"
        label="工种/岗位"
        prop="workerTypeId"
      >
        <el-select
          v-model="value.workerTypeId"
          placeholder="请选择工种/岗位"
        >
          <el-option
            v-for="item in workTypeList"
            :key="item.dictionaryId"
            :label="item.dictionaryName"
            :value="item.dictionaryId"
          />
        </el-select>
      </el-form-item>

    </el-form>

    <div
      slot="footer"
      class="dialog-footer"
    >
      <el-button @click="close">
        取 消
      </el-button>
      <el-button
        type="primary"
        :loading="submitLoading"
        @click="formOnSubmit('form')"
      >提交</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { mapState } from 'vuex'
import CommonSelect from '@/components/CommonSelect/index.vue'
import { siteProjectCompanyList } from '@/api/manage'
import { siteTeamTree } from '@/api/manage'
import { listByTypeCode } from '@/api/user'
export default {
  components: { CommonSelect },
  props: {
    value: {
      type: Object,
      default: () => {}
    },
    formInline: {
      type: Object,
      default: () => {}
    },
    submitLoading: {
      type: Boolean,
      default: false
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    type: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      rules: {
        companyId: [{ required: true, message: '请选择企业', trigger: 'blur' }],
        teamId: [{ required: true, message: '请选择班组', trigger: 'blur' }],
        workerTypeId: [
          { required: true, message: '请选择工种', trigger: 'blur' }
        ]
      },
      siteProjectCompanyList,
      companyParams: {
        projectId: this.$store.state.user.projectItem.projectId,
        pageSize: 999,
        pageNumber: 1
      },
      siteTeamTree,
      teamParams: {
        projectId: this.$store.state.user.projectItem.projectId,
        pageSize: 999,
        pageNumber: 1
      },
      workTypeList: []
    }
  },
  computed: {
    ...mapState({
      projectItem: (state) => state.user.projectItem
    })
  },
  mounted() {
    // if (this.formInline.personType === 'OTHER') {
    //   this.getWorkTypeList()
    // }
  },
  methods: {
    getWorkTypeList() {
      Promise.all([
        listByTypeCode({
          projectId: this.$store.state.user.projectItem.projectId,
          dictionaryTypeCode: 'workerType'
        }),
        listByTypeCode({
          projectId: this.$store.state.user.projectItem.projectId,
          dictionaryTypeCode: 'managerType'
        })
      ]).then((res) => {
        this.workTypeList = res[0].data.concat(res[1].data)
      })
    },
    close() {
      this.$emit('close')
    },
    formOnSubmit(formName) {
      const form = this.$refs[formName]
      form.validate((valid) => {
        if (valid) {
          this.$emit('formOnSubmit', formName)
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    companyChange(e) {
      this.teamParams.companyId = e
      this.$refs.CommonSelect.getData()
    }
  }
}
</script>

<style scoped>
::v-deep .el-select {
  width: 100%;
}
::v-deep .el-dialog__body {
  padding-top: 0px;
}
.chooseBtn {
  width: 100%;
}
</style>
<style >
.AllotDialog .el-dialog__body {
  min-height: auto;
}
</style>
